import React from 'react';
import { AppBar, Typography, Toolbar, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Logo from './images/mit.png';

const useStyles = makeStyles(theme => ({
  logo: {
    width: 64,
  },
  appBar: {
    backgroundColor: "white",
    maxHeight: 128,
    width: '100vw',
    padding: '4px 32px 4px 32px',
    [theme.breakpoints.down("sm")]: {
      paddingTop: 8,
      paddingBottom: 8,
    },
  },
  toolBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down("sm")]: {
      flexDirection: 'column',
    },
  },
  tabContainer: {
    [theme.breakpoints.down("sm")]: {
      display: 'flex',
      flexDirection: 'row',
    }
  },
  linkButton: {
    fontSize: 16,
    margin: '0px 4px 0px 4px',
    '&:hover': {
      backgroundColor: '#a31f34!important',
      color: 'white',
    }
  },
}));

function NavBar(props) {
  const classes = useStyles();

  return(
    <AppBar className={classes.appBar} position="sticky">
      <Toolbar className={classes.toolBar}>
        <a href="#">
          <img src={Logo} className={classes.logo} />
        </a>
        <div className={classes.tabContainer}>
          <a href="#Examples">
            <Button className={classes.linkButton}>
              Examples
            </Button>
          </a>  
          <a href="#Paper">
            <Button className={classes.linkButton}>
              Paper
            </Button>
          </a>
          <a href="#Code">
            <Button className={classes.linkButton}>
              Code
            </Button>
          </a>
          <a href="#Team">
            <Button className={classes.linkButton}>
              Team 
            </Button>
          </a>
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default NavBar;